/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderRadius } = borders;

export default {
  styleOverrides: {
    root: {
      width: pxToRem(260),
      whiteSpace: "nowrap",
      border: "none",
    },

    paper: ({ theme }) => ({
      width: pxToRem(260),
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(16, 20, 30, 0.98)" // Neutral dark navy — no tint
          : "rgba(255, 255, 255, 0.8)",
      backdropFilter: `saturate(180%) blur(${pxToRem(24)})`,
      height: `calc(100vh - ${pxToRem(32)})`,
      margin: pxToRem(16),
      borderRadius: borderRadius.xl,
      border:
        theme.palette.mode === "dark"
          ? "1px solid rgba(255, 255, 255, 0.06)"
          : "1px solid rgba(0, 0, 0, 0.06)",
      boxShadow:
        theme.palette.mode === "dark"
          ? "0 4px 24px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.04)"
          : "0 4px 24px rgba(0, 0, 0, 0.08)",
    }),

    paperAnchorDockedLeft: {
      borderRight: "none",
    },
  },
};
